module.exports = __webpack_public_path__ + "static/media/11.5beb261e.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/hats/11.png
// module id = 722
// module chunks = 0